import type { State, CustomMenuLink } from './types';

/**
 * User selectors for common state operations.
 * These selectors are designed to avoid cyclic dependencies.
 */

export const getAccountId = (state: State): string | undefined => {
	return state.persisted.user.accountId;
};

export const getEmail = (state: State) => {
	return state.persisted.user.email;
};

export const getDisplayName = (state: State): string => {
	return state.persisted.user.displayName || state.persisted.user.email || '';
};

export const isLoggedIn = (state: State): boolean => {
	return state.persisted.user.isLoggedIn;
};

export const getLocale = (state: State): string => {
	return state.persisted.user.language.key;
};

export const getCanAdministerJIRA = (state: State): boolean => {
	return state.persisted.user.canAdministerJIRA;
};

export const getHasSiteAdministerAccess = (state: State): boolean => {
	return state.persisted.user?.hasSiteAdministerAccess || false;
};

export const getCustomMenuLinks = (state: State): CustomMenuLink[] => {
	return state.persisted.user.customMenuLinks;
};

export const getAvatarSrc = (state: State): string | undefined => {
	return state.persisted.user.avatars?.xlarge;
};
